import type { MenuProps } from '@mui/material';

/**
 * A toolbar button's dropdown (Actions, Related): opens just under the button with its left edge on the button's, and
 * is never narrower than the button. The generated Actions menus use it too (entity-actions.ts).
 */
export function toolbarMenuProps(anchorEl: HTMLElement | null): Pick<MenuProps, 'anchorOrigin' | 'transformOrigin' | 'slotProps'> {
  return {
    anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
    transformOrigin: { vertical: 'top', horizontal: 'left' },
    slotProps: { paper: { sx: { mt: 0.5, minWidth: anchorEl?.offsetWidth } } },
  };
}
